<div class="login-page">
  <div class="page-wrap">
    <div class="form-wrapper">
      <div class="form-inner">
        <div class="logo">
          <img src="../../../assets/logo.svg" alt="CAIMS Logo" />
        </div>
        <h2>Password Reset</h2>
        <p class="welcome-text">Reset you password to continue using your account securely</p>

        <form ngNativeValidate (submit)="resetPassword()" *ngIf="showEmailForm">
          <div class="form-item form-floating mb-3">
            <input [(ngModel)]="email" name="email" type="email" class="form-control" id="floatingInput" placeholder=" " pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" required />
            <label for="floatingInput">Enter registered email address</label>
          </div>
          <button type="submit" class="btn login-btn">Reset password</button>
        </form>

        <form ngNativeValidate (submit)="checkCode()" *ngIf="showCodeForm">
          <div class="form-item form-floating mb-3">
            <input [(ngModel)]="code" name="code" type="text" class="form-control" id="floatingInput" placeholder=" " required />
            <label for="floatingInput">Enter code</label>
          </div>
          <button type="submit" class="btn login-btn">Submit</button>
        </form>

        <form ngNativeValidate (submit)="submitNewPw()" *ngIf="showPasswordForm">
          <div class="form-item form-floating">
            <input [(ngModel)]="pw" name="password" [type]="showPw ? 'text' : 'password'" class="form-control" id="floatingPassword" placeholder=" " required />
            <label for="floatingPassword">New password</label>
            <div class="show-pw" (click)="showPassword()">
              <ng-template [ngIf]="showPw">
                <img src="../../../assets/icons/eye.svg" alt="Show password icon" />
              </ng-template>
              <ng-template [ngIf]="!showPw">
                <img src="../../../assets/icons/eye-slash.svg" alt="Show password icon" />
              </ng-template>
            </div>
          </div>

          <div class="form-item form-floating">
            <input [(ngModel)]="confirmPw" name="password" [type]="showConfirmPw ? 'text' : 'password'" class="form-control" id="floatingPassword" placeholder=" " required />
            <label for="floatingPassword">Confirm password</label>
            <div class="show-pw" (click)="showConfirmPassword()">
              <ng-template [ngIf]="showConfirmPw">
                <img src="../../../assets/icons/eye.svg" alt="Show password icon" />
              </ng-template>
              <ng-template [ngIf]="!showConfirmPw">
                <img src="../../../assets/icons/eye-slash.svg" alt="Show password icon" />
              </ng-template>
            </div>
          </div>
          <button type="submit" class="btn login-btn">Save Password</button>
        </form>

        <div class="help"><a class="link" [routerLink]="''">Login Instead</a></div>
      </div>
    </div>
  </div>
  <p class="footer-text">Powered by <span class="bold-text">Beacon Power Services</span></p>
</div>

<div class="message-sent-wrapper" *ngIf="resetMessageSent" (click)="closeModal();">
  <div class="message-sent">
    <div class="close-btn" (click)="closeModal()"><div></div></div>
    <img src="../../../assets/animations/envelop-animation.gif" alt="Envelop animation">
    <h1>Reset message sent!</h1>
    <p>A password reset email has been sent to: <br/><strong>{{email}}</strong></p>
    <button class="btn login-btn" (click)="closeModal()">Enter code</button>
    <div class="help"><a class="link" [routerLink]="''">Back to Log in screen</a></div>
  </div>
</div>
